import {apiOption, apiResponse, errorResponse, only} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'

const NAMESPACE = 'Reference'
export const OPENING_TICKET_PURPOSE_REF_LOADED = NAMESPACE + '/OpeningTicketPurposeRefLoaded'
export const OPENING_TICKET_PURPOSE_REF_QUERIED = NAMESPACE + '/OpeningTicketPurposeRefQueried'
export const ACTIVITY_REF_LOADED = NAMESPACE + '/ActivityRefLoaded'
export const ACTIVITY_REF_QUERIED = NAMESPACE + '/ActivityRefQueried'
export const TICKET_CLAIM_REF_LOADED = NAMESPACE + 'TicketClaimRefLoaded'
export const CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/CreateOpeningTicketPurposeActionSent'
export const UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/UpdateOpeningTicketPurposeActionSent'
export const CREATE_UPDATE_TAG_ACTION_SENT = NAMESPACE + '/CreateUpdateTagActionSent'
export const CREATE_UPDATE_TAG_ACTION_RESET = NAMESPACE + '/CreateUpdateTagActionReset'
export const CREATE_UPDATE_CATEGORY_ACTION_SENT = NAMESPACE + '/CreateUpdateCategoryActionSent'
export const CREATE_UPDATE_CATEGORY_ACTION_RESET = NAMESPACE + '/CreateUpdateCategoryActionReset'
export const MOVE_PARENT_CATEGORY_ACTION_SENT = NAMESPACE + '/MoveParentCategoryActionSent'
export const ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/AddTagToOpeningTicketPurposeActionSent'
export const REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/RemoveTagFromOpeningTicketPurposeActionSent'
export const ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/AddCategoryToOpeningTicketPurposeActionSent'
export const REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/RemoveCategoryFromOpeningTicketPurposeActionSent'
export const ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/AssociateActivityWithOpeningTicketPurposeActionSent'
export const DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/DissociateActivityFromOpeningTicketPurposeActionSent'
export const ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/EnableOpeningTicketPurposeActionSent'
export const DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/DisableOpeningTicketPurposeActionSent'
// form actions
export const CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = NAMESPACE + '/CreateOpeningTicketPurposeActionUpdated'
export const UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = NAMESPACE + '/UpdateOpeningTicketPurposeActionUpdated'
export const CREATE_UPDATE_TAG_ACTION_UPDATED = NAMESPACE + '/CreateUpdateTagActionUpdated'
export const CREATE_UPDATE_CATEGORY_ACTION_UPDATED = NAMESPACE + '/CreateUpdateCategoryActionUpdated'
export const ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED = NAMESPACE + '/AssociateActivityWithOpeningTicketPurposeActionUpdated'

export function queryOpeningTicketPurposeRef(companyId) {
    return loadOpeningTicketPurposeRef(companyId, OPENING_TICKET_PURPOSE_REF_QUERIED)
}

export function fetchOpeningTicketPurposeRef(companyId) {
    return fetch(config.api.url + '/clientcompanies/' + companyId + '/openingticketpurposeref', apiOption())
        .then(apiResponse)

}

export function loadOpeningTicketPurposeRef(companyId, action) {
    return loading((state) => {
        const {company} = state.company
        companyId = (companyId && companyId.uid) || companyId || company.uid

        return fetchOpeningTicketPurposeRef(companyId).then(({json}) => {
            return {
                type: action || OPENING_TICKET_PURPOSE_REF_LOADED,
                ref: json
            }
        }).catch(only(404, (error) => {
            return {
                type: action || OPENING_TICKET_PURPOSE_REF_LOADED,
                ref: {
                    openingTicketPurposes: [],
                    categories: [],
                    tags: [],
                    default: {
                        openingTicketPurpose: {uid: '00000000-0000-0000-0000-000000000000', enabled: true, label: 'Autre raison d\'ouverture de Ticket', tags: [{uid: '11111111-1111-1111-1111-111111111111'}], categories: [], activities: []},
                        tag: {uid: '11111111-1111-1111-1111-111111111111', label: 'Autre', iconId: 'other'}
                    }
                }
            }
        }))
    }, action || OPENING_TICKET_PURPOSE_REF_LOADED)
}

export function queryActivityRef() {
    return loadActivityRef(ACTIVITY_REF_QUERIED)
}

export function loadActivityRef(action) {
    return loading(fetch(config.ticketHelper.api.url + '/universalactivitiesref', apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: action || ACTIVITY_REF_LOADED,
            ref: json.ref
        }
    }).catch(only(404, (error) => {
        return {
            type: action || ACTIVITY_REF_LOADED,
            ref: []
        }
    })), action || ACTIVITY_REF_LOADED)
}

export function loadTicketClaimRef() {
    return loading(fetch(config.api.url + '/ticketclaimref', apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: TICKET_CLAIM_REF_LOADED,
            ref: json
        }
    }).catch(only(404, (error) => {
        return {
            type: TICKET_CLAIM_REF_LOADED,
            ref: {
                urgencyLevel: [],
                ticketClaimCategory: [],
                failureCause: [],
                treatmentPriority: [],
                postAnalysis: [],
                severity: []
            }
        }
    })), TICKET_CLAIM_REF_LOADED)
}

export function sendCreateOpeningTicketPurposeAction() {
    return loading((state) => {
        const {company} = state.company
        const {createOpeningTicketPurposeAction} = state.reference
        const {tagUids, categoryUids, ...action} = createOpeningTicketPurposeAction

        const option = {
            method: 'PATCH',
            body: {
                action: 'CreateOpeningTicketPurpose',
                tagUids: tagUids && tagUids.map((t) => t.uid) || [],
                categoryUids: categoryUids && categoryUids.map((c) => c.uid) || [],
                ...action
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT,
                openingTicketPurposeUid: json.openingTicketPurposeUid
            }
        })
    }, CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendUpdateOpeningTicketPurposeAction() {
    return loading((state) => {
        const {company} = state.company
        const {updateOpeningTicketPurposeAction} = state.reference

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateOpeningTicketPurpose',
                ...updateOpeningTicketPurposeAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendCreateUpdateTagAction() {
    return loading((state) => {
        const {company} = state.company
        const {createUpdateTagAction} = state.reference

        const option = {
            method: 'PATCH',
            body: {
                ...createUpdateTagAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CREATE_UPDATE_TAG_ACTION_SENT,
                tagUid: json.tagUid || createUpdateTagAction.uid
            }
        })
    }, CREATE_UPDATE_TAG_ACTION_SENT)
}

export function sendCreateUpdateCategoryAction() {
    return loading((state) => {
        const {company} = state.company
        const {createUpdateCategoryAction} = state.reference
        const {parentUid, ...action} = createUpdateCategoryAction

        const option = {
            method: 'PATCH',
            body: {
                parentUid: parentUid && parentUid.uid,
                ...action
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CREATE_UPDATE_CATEGORY_ACTION_SENT,
                categoryUid: json.categoryUid || createUpdateCategoryAction.uid
            }
        })
    }, CREATE_UPDATE_CATEGORY_ACTION_SENT)
}

export function sendMoveParentCategoryAction(parentCategoryId, categoryId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'MoveParentCategory',
                parentUid: parentCategoryId,
                uid: categoryId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: MOVE_PARENT_CATEGORY_ACTION_SENT
            }
        })
    }, MOVE_PARENT_CATEGORY_ACTION_SENT)
}

export function sendAddTagToOpeningTicketPurposeAction(openingTicketPurposeId, tagId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'AddTagToOpeningTicketPurpose',
                uid: openingTicketPurposeId,
                tagUid: tagId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendRemoveTagFromOpeningTicketPurposeAction(openingTicketPurposeId, tagId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'RemoveTagFromOpeningTicketPurpose',
                uid: openingTicketPurposeId,
                tagUid: tagId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendAddCategoryToOpeningTicketPurposeAction(openingTicketPurposeId, categoryId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'AddCategoryToOpeningTicketPurpose',
                uid: openingTicketPurposeId,
                categoryUid: categoryId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendRemoveCategoryFromOpeningTicketPurposeAction(openingTicketPurposeId, categoryId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'RemoveCategoryFromOpeningTicketPurpose',
                uid: openingTicketPurposeId,
                categoryUid: categoryId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendAssociateActivityWithOpeningTicketPurposeAction() {
    return loading((state) => {
        const {company} = state.company
        const {associateActivityWithOpeningTicketPurposeAction} = state.reference
        const {uid, activityUid, ...action} = associateActivityWithOpeningTicketPurposeAction

        const option = {
            method: 'PATCH',
            body: {
                action: 'AssociateActivityWithOpeningTicketPurpose',
                uid: uid && uid.uid,
                activityUid: activityUid && activityUid.uid
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendDissociateActivityFromOpeningTicketPurposeAction(openingTicketPurposeId, activityId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'DissociateActivityFromOpeningTicketPurpose',
                uid: openingTicketPurposeId,
                activityUid: activityId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT,
                providerContactUpdated: json.providerContactUpdated
            }
        })
    }, DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendEnableOpeningTicketPurposeAction(openingTicketPurposeId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'EnableOpeningTicketPurpose',
                uid: openingTicketPurposeId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function sendDisableOpeningTicketPurposeAction(openingTicketPurposeId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'DisableOpeningTicketPurpose',
                uid: openingTicketPurposeId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT
            }
        })
    }, DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT)
}

export function updateCreateOpeningTicketPurposeAction(action) {
    return {
        action: action,
        type: CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
    }
}

export function updateUpdateOpeningTicketPurposeAction(action) {
    return {
        action: action,
        type: UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
    }
}

export function updateCreateUpdateTagAction(action) {
    return {
        action: action,
        type: CREATE_UPDATE_TAG_ACTION_UPDATED
    }
}

export function resetCreateUpdateTagAction(action = null) {
    return {
        action: action,
        type: CREATE_UPDATE_TAG_ACTION_RESET
    }
}

export function updateCreateUpdateCategoryAction(action) {
    return {
        action: action,
        type: CREATE_UPDATE_CATEGORY_ACTION_UPDATED
    }
}

export function resetCreateUpdateCategoryAction(action = null) {
    return {
        action: action,
        type: CREATE_UPDATE_CATEGORY_ACTION_RESET
    }
}

export function updateAssociateActivityWithOpeningTicketPurposeAction(action) {
    return {
        action: action,
        type: ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED
    }
}


// WEBPACK FOOTER //
// ./lib/reference/actions.js